import React, { useEffect, useState } from 'react'
import HeaderComponents from '../../components/HeaderComponents';
import "../../utils/Style/pages/ToDo.scss";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { roleAuth } from '../../utils/functionAuthorization';
import { setTodoActiveButton } from '../../features/TodoSlice';
import OrderTable from './OrderTable';
import OrderToPrepare from './OrderToPrepare';
import useTodoApi from '../../api/TodoApi';


function ToDo() {

  const dispatch = useDispatch();
  const activeButton = useSelector((state) => state.todo.todoActiveButton);
  const webSocketMessage = useSelector((state) => state.websocket.webSocketMessage);
  const { GetOrdersToProcess, GetOrder, isLoading, GetOrdersToProcessCount} = useTodoApi();

  const location = useLocation();
  const name = location.state?.name;

  const accessPoints = {
    prepareOrder: "PREPARE_ORDER"
  }

  const defaultActiveButton = roleAuth("todo", accessPoints.prepareOrder ? "OrderTable" : "");

  const [activeButtonLocal, setActiveButtonLocal] = useState({
    name: defaultActiveButton,
  });

  useEffect(() => {
    if(webSocketMessage) {
      const messageData = JSON.parse(webSocketMessage.message.data);
      
      if(messageData.Event === "OrderAssigned") {
          GetOrdersToProcess();
          GetOrdersToProcessCount();
      }}
      
  })

  useEffect(() => {
    dispatch(setTodoActiveButton({ name: "OrderTable" }));
  }, [])

  useEffect(() => {
    if(name !== undefined) {
      setActiveButtonLocal({ name });
    }
  }, [name, activeButton])

  
  return (
    <>   
    <HeaderComponents title="Orders to Prepare" />
      <div className='ToDoPage'>
     
        <div className='TodoContainerPage'>
          <div className='row'>
          {activeButton?.name === "OrderTable" && (
              <OrderTable setActiveButton={setActiveButtonLocal} accessPoints={accessPoints}/>
            )}
            {activeButton?.name === "OrderToPrepare" && (
              <OrderToPrepare setActiveButton={setActiveButtonLocal} accessPoints={accessPoints}/>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ToDo;